import { useConsent } from '@lichtblick/consent';

import styles from './vario-video.module.css';

export const VarioVideo = () => {
  const youtubeConsent = useConsent('YouTube Video');

  if (!youtubeConsent) {
    return null;
  }

  return (
    <iframe
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen={true}
      className={styles.iframe}
      loading="lazy"
      src="https://www.youtube-nocookie.com/embed/TYLQLNUrFLM?autoplay=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
      title="YouTube video player"
    />
  );
};
